/* Secondary card images are inert until pointer or keyboard intent. */
(() => {
  const pending = new WeakSet();
  const desktop = window.matchMedia('(min-width: 990px)');
  let touchFocus = false;
  let pointerType = '';

  function hydrate(event) {
    if (!desktop.matches || (event.type === 'focusin' && touchFocus)) return;
    if (event.type === 'pointerover' && event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
    const card = event.target.closest?.('.product-card-wrapper');
    const template = card?.querySelector('.card__media > .media > template[data-neo-card-secondary]');
    if (!template || pending.has(template)) return;
    const source = template.content.querySelector('img');
    // Import into the active document: template clones retain an inert ownerDocument.
    const image = source && document.importNode(source, true);
    if (!image) return;
    pending.add(template);
    const media = template.parentElement;

    function reveal() {
      if (!template.isConnected) return;
      // Insert immediately after the primary: the theme owns img + img hover styles.
      media.firstElementChild.after(image);
      media.classList.add('neo-card-secondary-ready');
      template.remove();
    }

    image.addEventListener('load', reveal, { once: true });
    image.addEventListener('error', () => pending.delete(template), { once: true });
    // Off-DOM lazy images do not load; original srcset/sizes/alt stay untouched.
    image.loading = 'eager';
    if (image.complete && image.naturalWidth > 0) reveal();
  }

  // Track modality before the pointer's default focus action; keyboard can resume.
  document.addEventListener('pointerdown', (event) => {
    pointerType = event.pointerType;
    touchFocus = pointerType === 'touch';
  }, { capture: true, passive: true });
  document.addEventListener('keydown', () => { touchFocus = false; }, true);

  // Delegation also covers cards inserted by filters and recommendations.
  document.addEventListener('pointerover', (event) => {
    pointerType = event.pointerType;
    hydrate(event);
  }, { passive: true });
  document.addEventListener('focusin', hydrate);
  // A newly displayable secondary should honor intent held across the breakpoint.
  desktop.addEventListener('change', () => {
    if (!desktop.matches) return;
    hydrate({ type: 'focusin', target: document.activeElement });
    const hovered = document.querySelector('.product-card-wrapper:hover');
    if (hovered) hydrate({ type: 'pointerover', pointerType, target: hovered });
  });
})();
